import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.457 1.11a1 1 0 0 1 .524 1.086l-1.834 9.166 7.204 2.702a1 1 0 0 1 .38 1.618l-14 15a1 1 0 0 1-1.712-.878l1.834-9.166-7.204-2.702a1 1 0 0 1-.38-1.618l14-15a1 1 0 0 1 1.188-.208M7.752 16.59l6.6 2.475a1 1 0 0 1 .629 1.132l-1.31 6.548 10.577-11.333-6.6-2.475a1 1 0 0 1-.629-1.132l1.31-6.548z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconLightning = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLightning);
export default Memo;
